import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { toHugeDate, toTime } from '../../../utils/date';
import { MaintenancePeriod } from '../../models/maintenance-period';

@Component({
    selector: 'app-maintenance-period-card',
    imports: [TranslatePipe],
    templateUrl: './maintenance-period-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './maintenance-period-card.component.scss',
})
export class MaintenancePeriodCardComponent {
    readonly period = input<MaintenancePeriod | null>(null);

    protected readonly notice = computed(() => {
        const period = this.period();
        return (
            period && {
                date: toHugeDate(period.startDate),
                startTime: toTime(period.startDate),
                endTime: toTime(period.endDate),
            }
        );
    });
}
